module.exports = __webpack_public_path__ + "vendor/ionicons_dd4781d1.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/eulo/repos/CodeDrips/round3/wp-content/themes/round3/node_modules/ionicons-pre/fonts/ionicons.ttf
// module id = 90
// module chunks = 0